<template>
  <div class="btn button">
    <div class="bi-arrow-left-circle-fill mx-auto b-icon bi icon-right">
      <slot name="p-1" />
    </div>
    <div class="label">
      <slot name="p-2" />
    </div>
    <div class="bi-arrow-left-circle-fill mx-auto b-icon bi icon-left">
      <slot name="p-3" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Bt503",
};
</script>

<style scoped>
.button {
  background-color: var(--light-red);
  color: var(--light) !important;
  transition: all 0.3s ease-in-out;
}

.button * {
  transition: all 0.3s ease-in-out;
}

.icon-right * {
  width: 0;
  margin-left: 13px !important;
}

.button:hover > .icon-right * {
  width: 20px;
}

.label,.button:hover > .label {
  font-weight: bold;
  display: inline-block !important;
}

.icon-left * {
  margin-right: 13px !important;
}

.button:hover > .icon-left * {
  z-index: 100000;
  width: 0;
}
</style>
